import styled from 'styled-components';
import { animated } from 'react-spring';

import { BREAKPOINTS } from 'config/constants';

import BlurredBackground from 'components/BlurredBackground';
import Card from 'components/Card';

export const Background = styled(BlurredBackground)`
  height: 100%;
  left: 0;
  margin: auto;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1;
`;

export const Wrapper = styled.div`
  height: calc(100vh - 13.4rem);
  overflow: hidden;
  position: relative;
  width: 100%;
`;

export const CARD_WIDTH = 500;
export const CARD_MARGIN = 30;

export const TourWrapper = styled(animated.div)`
  align-items: center;
  display: flex;
  height: 100%;
  left: ${({ pagewidth }) => `${pagewidth / 2 - (CARD_WIDTH / 2 + CARD_MARGIN)}px`};
  position: absolute;
  width: 100%;
  z-index: 3;

  @media screen and (max-width: ${BREAKPOINTS.SM}px) {
    align-items: flex-start;
    left: 0;
    padding-top: 4rem;
  }
`;

export const StyledContent = styled(Card.Content)`
  padding: 3rem;

  @media screen and (max-width: ${BREAKPOINTS.SM}px) {
    padding: 2rem;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 1.5rem;
  width: 100%;
`;

export const CardWrapper = styled.div`
  cursor: ${({ $active }) => !$active && 'pointer'};
  margin: ${CARD_MARGIN / 10}rem;
  min-width: ${CARD_WIDTH / 10}rem;
  max-width: ${CARD_WIDTH / 10}rem;
  opacity: ${({ $active }) => ($active ? '1' : '0.1')};
  transition: opacity 0.25s ease-in-out;
  &:hover {
    opacity: ${({ $active }) => !$active && '0.3'};
  }

  @media screen and (max-width: ${BREAKPOINTS.SM}px) {
    margin: 2rem;
    min-width: calc(100vw - 4rem);
    max-width: calc(100vw - 4rem);
    width: calc(100vw - 4rem);
  }
`;

export const StepLabel = styled.div`
  color: #fff;
  font-weight: 600;
  font-size: 1rem;
  letter-spacing: 0.15em;
  margin-top: 0.8rem;
  text-align: right;
  text-transform: uppercase;
`;

export const DescriptionContainer = styled.div`
  p {
    margin-top: 0.5rem;

    &:first-child {
      margin-top: 0;
    }
  }

  u {
    text-decoration-line: underline;
  }
`;
